/**
 * O endereço do formulário em duas camadas (`CamposDoEndereco`), em partes
 * para as etiquetas. Puro, para o teste provar as frases sem desenhar a tela.
 */

export type CampoDoEndereco = 'cep' | 'logradouro' | 'numero' | 'bairro' | 'uf' | 'municipio';

export type ValoresDoEndereco = Readonly<Record<CampoDoEndereco, string>>;

/**
 * O endereço em etiquetas (`EtiquetaDoPreenchido`, rótulo e valor): a rua com
 * o número, o bairro e a cidade com a UF. Só as que têm valor; vazio quando
 * não há endereço nenhum além do CEP.
 */
export function partesDoEndereco(v: Partial<ValoresDoEndereco>): readonly { readonly rotulo: string; readonly valor: string }[] {
  const limpo = (texto: string | undefined) => (texto ?? '').trim();
  const rua = limpo(v.logradouro);
  const numero = limpo(v.numero);
  const municipio = limpo(v.municipio);
  const uf = limpo(v.uf);
  const partes = [
    { rotulo: 'Rua', valor: rua === '' ? (numero === '' ? '' : `número ${numero}`) : numero === '' ? rua : `${rua}, ${numero}` },
    { rotulo: 'Bairro', valor: limpo(v.bairro) },
    { rotulo: 'Cidade', valor: municipio === '' ? uf : uf === '' ? municipio : `${municipio}/${uf}` },
  ];
  return partes.filter((parte) => parte.valor !== '');
}

/** Os seis campos do endereço, lidos de um formulário que guarda tudo como texto. */
export function enderecoDe(valores: Readonly<Record<string, string | undefined>>): ValoresDoEndereco {
  return {
    cep: valores['cep'] ?? '',
    logradouro: valores['logradouro'] ?? '',
    numero: valores['numero'] ?? '',
    bairro: valores['bairro'] ?? '',
    uf: valores['uf'] ?? '',
    municipio: valores['municipio'] ?? '',
  };
}

/** O campo pertence ao endereço? O formulário genérico desenha os seis de uma vez. */
export function ehCampoDoEndereco(nome: string): nome is CampoDoEndereco {
  return nome === 'cep' || nome === 'logradouro' || nome === 'numero' || nome === 'bairro' || nome === 'uf' || nome === 'municipio';
}
